module.exports = __webpack_public_path__ + "dist/introduce_2.837af821.png";